<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="xl:px-9 lg:px-[34px] sm:px-[22px] px-[18px] w-full">
    <div
      class="flex flex-col-reverse md:flex-row justify-between items-center w-full border-t py-4 border-gray-300"
    >
      <div class="my-4 text-gray-500 text-xs">
        Copyright &copy; {{ new Date().getFullYear() }} Polka. Все права защищены
      </div>
      <div class="text-xs text-gray-700">
        Используя сайт, вы принимаете условия
        <NuxtLink
          :to="$localePath('/oferta')"
          class="text-blue-500 font-semibold"
        >
          оферты
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
